import { BaseService } from '../../infra/base.service'
import type { Category } from './category'
import type { CategoriesRepository } from './categories.repository'

export class CategoriesService extends BaseService<Category> {
    constructor(private rep: CategoriesRepository) {
        super(rep)
    }

    async addDefaults() {
        return await this.rep.addDefaults()
    }
}
